import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import App from './App'
import './styles/app.css'
import './styles/desktop-shell-fix.css'
import './styles/footer-socials.css'
import './styles/register-mobile-lock.css'

async function prepareServiceWorker(){
  if(!('serviceWorker' in navigator))return
  if(import.meta.env.DEV){
    const registrations=await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map(registration=>registration.unregister()))
    if('caches' in window){const names=await caches.keys();await Promise.all(names.map(name=>caches.delete(name)))}
    return
  }
  window.addEventListener('load',async()=>{
    try{
      const registration=await navigator.serviceWorker.register('/sw.js',{updateViaCache:'none'})
      await registration.update()
      if(registration.waiting)registration.waiting.postMessage({type:'SKIP_WAITING'})
      registration.addEventListener('updatefound',()=>{
        const worker=registration.installing
        worker?.addEventListener('statechange',()=>{if(worker.state==='installed'&&navigator.serviceWorker.controller)worker.postMessage({type:'SKIP_WAITING'})})
      })
      let refreshed=false
      navigator.serviceWorker.addEventListener('controllerchange',()=>{if(refreshed)return;refreshed=true;window.location.reload()})
    }catch{}
  })
}
void prepareServiceWorker()

const root=document.getElementById('root')
if(!root)throw new Error('Application root element was not found.')
createRoot(root).render(<StrictMode><BrowserRouter><AuthProvider><App/></AuthProvider></BrowserRouter></StrictMode>)